import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import EmptyArticle from 'components/EmptyArticle';
import MagazineArticle from 'containers/MagazineArticle';
import ForumThread from 'containers/ForumThreadsList/ForumThread';
import NoEntries from 'components/NoEntries';
import NoEntriesDetail from 'components/NoEntries/NoEntriesDetail';

import SearchPageSelector from './SearchPageSelector';
import SearchTabNavigation from './SearchTabNavigation';
import SearchComment from './SearchComment';

import { locationShape } from 'react-router/lib/PropTypes';
import { SearchItemShape } from 'entities';
import { offsetToPageParams } from 'utils/api';
import { isRootComment, isCommentReply, findCommentsOwnerType } from 'commentsResourceTypes';
import * as actions from 'actions';
import { getSearchPaging, getSearchTabs, getSearchResults } from 'selectors';

class Search extends Component {

  componentDidMount() {
    this.props.onSearchItemsFetch(this.props.query);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.props.onSearchItemsFetch(this.props.query);
    }
  }

  componentWillUnmount() {
    if(this.props.onWillUnmount) {
      this.props.onWillUnmount();
    }
  }

  renderEmptyArticles() {
    return [
      <EmptyArticle key="loader1" isDarker />,
      <EmptyArticle key="loader2" isDarker />,
      <EmptyArticle key="loader3" isDarker />
    ];
  }

  renderNoSearchResults() {
    return (
      <NoEntries title={__('members.search.noResults.title')}>
        <NoEntriesDetail>{__('members.search.noResults.subtitle')}</NoEntriesDetail>
      </NoEntries>
    );
  }

  renderSearchResult(searchResult) {
    const { article, comment, forumThread } = searchResult;

    if (article) return this.renderMagazineArticle(article);
    if (comment) return this.renderComment(comment);
    if (forumThread) return this.renderForumThread(forumThread);
  }

  renderMagazineArticle(magazineArticle) {
    return (
      <MagazineArticle
        key={magazineArticle.id}
        magazineArticle={magazineArticle}
        imageUrl={magazineArticle.thumbnail.main.lowRes}
        inFeed
        shouldOpenProfileFromImage
      />
    );
  }

  renderComment(comment) {
    const { id, resourceType, origin, parentComment } = comment;
    let originUrl = '';
    let commentUrl = '';
    const commentsPage = offsetToPageParams(origin.offset, process.env.KOOTH_PAGE_SIZE).page;

    if (findCommentsOwnerType(resourceType) === 'article') originUrl = `/magazine/articles/${origin.id}`;
    if (findCommentsOwnerType(resourceType) === 'forumThread') originUrl = `/forum/threads/${origin.id}`;

    if (isRootComment(resourceType)) commentUrl = `${originUrl}/comments/${commentsPage}/${id}`;
    if (parentComment && isCommentReply(resourceType)) {
      const nestedCommentsPage = offsetToPageParams(parentComment.offset, process.env.KOOTH_COMMENT_REPLIES_PAGE_SIZE).page;
      commentUrl = `${originUrl}/comments/${commentsPage}/${parentComment.id}/${nestedCommentsPage}/${id}`;
    }

    return (
      <SearchComment
        key={comment.id}
        comment={comment}
        originUrl={originUrl}
        originTitle={origin.title}
        commentUrl={commentUrl}
      />
    );
  }

  renderForumThread(forumThread) {
    return <ForumThread isInline forumThread={forumThread} key={forumThread.id} />;
  }

  render() {
    return (
      <section className="content-wrapper has-background">
        <div className="wrapper-small is-collapsed is-padded-vertical">

          <div className="feed-layout">
            <div className="container">
              <div className="wrapper-small is-collapsed">
                <div className="title">
                  <h1>
                    <span className="head">{__('members.search.resultsTitle')}</span> {this.props.query.term}
                  </h1>
                </div>

                <SearchTabNavigation term={this.props.query.term} />

                {(() => {
                  if (this.props.isFetching) {
                    return this.renderEmptyArticles();
                  } else if (this.props.searchResults.length > 0) {
                    return this.props.searchResults.map(searchResult => this.renderSearchResult(searchResult));
                  } else if (this.props.totalCount === 0) {
                    return this.renderNoSearchResults();
                  }
                })()}

              </div>
            </div>
          </div>

          <div className="pagination-wrapper">
            <div className="wrapper-xlarge">
              {this.props.pagesCount > 1 && <SearchPageSelector query={this.props.query} queryString={this.props.queryString} />}
            </div>
          </div>

        </div>
      </section>
    );
  }
}

Search.propTypes = {
  location: locationShape,
  query: PropTypes.shape({
    term: PropTypes.string,
    category: PropTypes.string
  }),
  queryString: PropTypes.string,
  searchResults: PropTypes.arrayOf(SearchItemShape),
  isFetching: PropTypes.bool,
  pagesCount: PropTypes.number,
  totalCount: PropTypes.number,
  selectedTab: PropTypes.string,
  onSearchItemsFetch: PropTypes.func,
  onWillUnmount: PropTypes.func
};

const mapStateToProps = (state, props) => {
  const term = props.location.query.term;
  const { selectedTab, isFetching } = getSearchTabs(state);
  const query = { term, category: selectedTab };
  const queryString = JSON.stringify(query);

  const { page, pagesCount, totalCount } = getSearchPaging(state, 'results', { queryString });
  const searchResults = getSearchResults(state, { page, queryString });

  return {
    selectedTab,
    searchResults,
    isFetching,
    query,
    queryString,
    pagesCount,
    totalCount
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSearchItemsFetch: (query) => {
      const magazineQuery = {...query, category: 'magazine'};
      const forumQuery = {...query, category: 'forum'};

      dispatch(actions.searchItemsFetch(1, magazineQuery, JSON.stringify(magazineQuery)));
      dispatch(actions.searchItemsFetch(1, forumQuery, JSON.stringify(forumQuery)));
    },
    onWillUnmount: () => {
      dispatch(actions.searchHide());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Search/index.js
 **/